define('modules/base/models/contact.search.model',[
    'underscore',
    'backbone',
    'modules/base/models/base.paging.model'
], function (_, Backbone, BasePagingModel) {
    var ContactSearchModel = BasePagingModel.extend({
        state: false,
        base: 'search',
        showPastRoles: "true",
        extendedParams:function(){
            var base = "&showPastRole=" + this.showPastRoles;
            if(this.state){
                if (this.firstName != '') {
                    base += '&firstName=' + encodeURIComponent(this.firstName);
                }
                if (this.lastName != '') {
                    base += '&lastName=' + encodeURIComponent(this.lastName);
                }
                if (this.orgName != '') {
                    base += '&orgName=' + encodeURIComponent(this.orgName);
                }
                if (this.title != '' ) {
                    base += '&title=' + encodeURIComponent(this.title);
                }
            }else{
                if (this.query != undefined && this.query != "") {
                    base += '&query=' + encodeURIComponent(this.query);
                }
            }
            return base;
        }
    });
    return ContactSearchModel;
});

